import baseURL from "../common/axios";
class Commonservices {
  // Login(objlogin) {
  //   debugger;
  //   return baseURL.httpbaseURL.post("DoctorLogIn/LoginVerification", objlogin);
  // }
  Login(UserId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Login/GetLoginVerification?UserId=" + UserId + ""
    );
  }
  GetRoles(EmailId, Password) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Login/GetRoles?EmailId=" + EmailId + "&Password=" + Password + ""
    );
  }
  GetRolesByUserId(UserId, BranchId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Login/GetRolesByUserId?UserId=" + UserId + "&BranchId=" + BranchId + ""
    );
  }
  GetBranchesByUserId(UserId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Login/GetBranchesByUserId?UserId=" + UserId + ""
    );
  }
  LogOut(Key) {
    debugger;
    return baseURL.httpbaseURL.post("Common/LogoutSession?key=" + Key + "");
  }
  Session(objlogin) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.post("Common/Session", objlogin);
  }
  GetCountry(data) {
    return baseURL.httpbaseURL.post("DoctorCreation/GetCountry", data);
  }
}
export default new Commonservices();
